import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-167">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6" aria-modal="true" role="dialog" data-id="element-168">
          <div className="absolute inset-0 bg-ink/40 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-169" />
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-cream rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden border border-blush/30" data-id="element-170">
            <div className="flex items-center justify-between p-6 md:p-8 border-b border-blush/30 bg-blush-soft" data-id="element-171">
              <h2 className="font-serif text-2xl md:text-3xl text-ink" data-id="element-172">
                {title}
              </h2>
              <button onClick={onClose} className="flex-shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-white hover:bg-blush hover:text-white transition-colors duration-200 text-ink" aria-label="Cerrar" data-id="element-173">
                <XIcon className="w-5 h-5" data-id="element-174" />
              </button>
            </div>
            <div className="overflow-y-auto p-6 md:p-8 text-ink-soft leading-relaxed" data-id="element-175">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}